function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Copy partial data into the target message.
 *
 * If a singular scalar or enum field is present in the source, it
 * replaces the field in the target.
 *
 * If a singular message field is present in the source, it is merged
 * with the target field by calling mergePartial() of the responsible
 * message type.
 *
 * If a repeated field is present in the source, its values replace
 * all values in the target array, removing extraneous values.
 * Repeated message fields are copied, not merged.
 *
 * If a map field is present in the source, entries are added to the
 * target map, replacing entries with the same key. Entries that only
 * exist in the target remain. Entries with message values are copied,
 * not merged.
 *
 * Note that this function differs from protobuf merge semantics,
 * which appends repeated fields.
 */
export function reflectionMergePartial(info, target, source) {
  var fieldValue,
      // the field value we are working with
  input = source,
      output; // where we want our field value to go

  var _iterator = _createForOfIteratorHelper(info.fields),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var field = _step.value;
      var name = field.localName;

      if (field.oneof) {
        var group = input[field.oneof]; // this is the oneof`s group in the source

        if ((group === null || group === void 0 ? void 0 : group.oneofKind) == undefined) {
          // the user is free to omit
          continue; // we skip this field, and all other members too
        }

        fieldValue = group[name]; // our value comes from the the oneof group of the source

        output = target[field.oneof]; // and our output is the oneof group of the target

        output.oneofKind = group.oneofKind; // always update discriminator

        if (fieldValue == undefined) {
          delete output[name]; // remove any existing value

          continue; // skip further work on field
        }
      } else {
        fieldValue = input[name]; // we are using the source directly

        output = target; // we want our field value to go directly into the target

        if (fieldValue == undefined) {
          continue; // skip further work on field, existing value is used as is
        }
      }

      if (field.repeat) output[name].length = fieldValue.length; // resize target array to match source array
      // now we just work with `fieldValue` and `output` to merge the value

      switch (field.kind) {
        case "scalar":
        case "enum":
          if (field.repeat) for (var i = 0; i < fieldValue.length; i++) {
            output[name][i] = fieldValue[i];
          } // not a reference type
          else output[name] = fieldValue; // not a reference type

          break;

        case "message":
          var T = field.T();
          if (field.repeat) for (var _i = 0; _i < fieldValue.length; _i++) {
            output[name][_i] = T.create(fieldValue[_i]);
          } else if (output[name] === undefined) output[name] = T.create(fieldValue); // nothing to merge with
          else T.mergePartial(output[name], fieldValue);
          break;

        case "map":
          // Map and repeated fields are simply overwritten, not appended or merged
          switch (field.V.kind) {
            case "scalar":
            case "enum":
              Object.assign(output[name], fieldValue); // elements are not reference types

              break;

            case "message":
              var _T = field.V.T();

              for (var _i2 = 0, _Object$keys = Object.keys(fieldValue); _i2 < _Object$keys.length; _i2++) {
                var k = _Object$keys[_i2];
                output[name][k] = _T.create(fieldValue[k]);
              }

              break;
          }

          break;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}